import "./aboutMe.css";
import avatar from "../../Assets/img/Avatar.png";

const AboutMe = () => {
  return (
    <div className="containerAboutMe">
      <div className="containerImg">
        <img src={avatar} alt="foto de perfil" />
      </div>
      <div className="containerAboutMeText">
        <h2>
          Apaixonado por tecnologia desde cedo, no meio da pandemia resolvi
          tentar aprender algo novo, a programação.
          <br />
          Me apaixonei logo de inicio e sigo estudando ate o momento.
          <br />
          Me considero uma pessoa esforçada e entusiasta com novas tecnologias,
          sempre buscando aprender coisas novas e buscando novos desafios.
        </h2>
      </div>
    </div>
  );
};
export default AboutMe;
